var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserGroupSolid = function SvgUserGroupSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M18 17.124a.625.625 0 0 1-.5 1.001h-15a.625.625 0 0 1-.5-1 5.3 5.3 0 0 1 2.14-1.694 3.125 3.125 0 1 1 4.214 0c.613.264 1.17.643 1.64 1.116a5.3 5.3 0 0 1 1.641-1.117 3.125 3.125 0 1 1 4.213 0c.854.367 1.595.951 2.152 1.694M2.125 9.875A.625.625 0 0 0 3 9.75a4.062 4.062 0 0 1 6.5 0 .625.625 0 0 0 1 0 4.062 4.062 0 0 1 6.5 0A.625.625 0 1 0 18 9a5.3 5.3 0 0 0-2.14-1.695 3.125 3.125 0 1 0-4.214 0 5.3 5.3 0 0 0-1.64 1.117 5.3 5.3 0 0 0-1.641-1.117 3.125 3.125 0 1 0-4.213 0A5.3 5.3 0 0 0 2 9a.625.625 0 0 0 .125.875"
  })));
};
export default SvgUserGroupSolid;